import React, { useEffect, useState } from 'react';
import AdminModal from './modals/admin/AdminModal';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/HomePage/Home';
import './App.css';
import Events from './pages/EventsPage/Events';
import About from './pages/AboutPage/About';
import Support from './pages/SupportPage/Support';
import Contact from './pages/Contact/Contact';
import { logoutAdmin, sendAdminKey } from './api/api';
import { useAdminHotkey } from './modals/admin/useAdminHotkey';
import EditEvent from './pages/EditEvent/EditEvent';
import ProtectedRoute from './components/ProtectedRoute';
import ViewEvent from './pages/ViewEvent/ViewEvent';
import ShowGallery from './pages/ShowGallery/ShowGallery';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(() => localStorage.getItem('isAdmin') === 'true');

    useEffect(() => {
      const syncAdminState = (event) => {
        setIsAdmin(event?.detail?.isAdmin === true);
      };

      window.addEventListener('admin-auth-changed', syncAdminState);
      return () => window.removeEventListener('admin-auth-changed', syncAdminState);
    }, []);

    useAdminHotkey(() => {
        setIsModalOpen(true);
    });

    const handleSubmit = async (key) => {
      try {
          const response = await sendAdminKey(key);
          
          if (response.result) {
              return true;
          } else {
              throw new Error(response.message || 'Nieprawidłowy klucz');
          }
      } catch (error) {
          console.error('Błąd autoryzacji:', error);
          throw error; 
      }
  };

    const handleLogout = () => {
      logoutAdmin();
      setIsModalOpen(false);
      window.location.replace('/');
    };


  return (
    <div>
      <Layout>
        <AdminModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleSubmit}
          isAdmin={isAdmin}
          onLogout={handleLogout}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/about" element={<About />} />
          <Route path="/support" element={<Support />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Home />} />
          <Route path="/view-event/:id" element={<ViewEvent />} />
          <Route path="/show-gallery" element={<ShowGallery />} />

          <Route path="/edit-event/:id" element={
            <ProtectedRoute>
              <EditEvent />
            </ProtectedRoute>
          } />
          <Route path="/create-event" element={
            <ProtectedRoute>
              <EditEvent type="create" />
            </ProtectedRoute>
          } />
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
